/**
 * SIDCDatawarehousePurchasing
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpSertDraftGoodsReceiptPOCommandDetail { 
    id?: number;
    barcode?: string;
    itemCode?: string;
    itemDescription?: string;
    unitOfMeasureCode?: string;
    quantity?: number;
    idUser?: string;
    systemDate?: Date;
    warehouseCode?: string;
    conversion?: number;
    price?: number;
    total?: number;
    lineNumber?: number;
}